import AnimatedSaltLogo from "../Logos/AnimatedSaltLogo";

const SaltBrandHeader = ({
	text = `Know your money<br /> to grow your money`,
}: {
	text?: string;
}) => {
	return (
		<div className="flex">
			<div className="pr-x-5 flex align-items-center">
				<AnimatedSaltLogo height={32} width={58} />
			</div>
			<div
				className="pl-x-5 font-secondary fs-14 fw-400 flex align-items-center color-abyssal-blue-400"
				style={{
					borderLeft: `1px solid var(--abyssal-blue-400)`,
				}}
				dangerouslySetInnerHTML={{ __html: text }}
			/>
		</div>
	);
};

export default SaltBrandHeader;
